import { Component, Input, OnInit } from '@angular/core';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'webcam',
    templateUrl: './webcam.component.html',
    styleUrls: ['./webcam.component.scss'],
    standalone: false
})
export class WebcamComponent implements OnInit {

  @Input() dynamicContent: Models.DynamicContent;
  @Input() parent: Models.DynamicContentEntrance;
  @Input() create = false;
  @Input() onlyTitle = false;

  constructor() {
  }

  ngOnInit(): void {
  }
}
